// extracted by mini-css-extract-plugin
module.exports = {"container":"pagination_container__zYvXc","pagination":"pagination_pagination__39had","perPage":"pagination_perPage__26LSU","dropdown":"pagination_dropdown__33XVY"};